var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5"},[_c('PageTitle',{staticClass:"mt-2",attrs:{"title":"Horário de Funcionamento"}}),_vm._l((_vm.fields),function(days,index){return _c('b-row',{key:index},[_c('b-col',[_c('OpenShop',{staticClass:"mt-5",attrs:{"days":days.day,"open":days.open,"close":days.close,"dataShop":_vm.dataShop}})],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }